import { has } from 'lodash';
import { sendGraph } from '@fiverr-private/futile';
import { stats } from '@fiverr-private/obs';
import { PREFIX, BASE_LEGACY_PARAMS } from './constants';

export const reportGrafanaEvent = (label) => {
    const isLegacyReporter = has(window, 'Fiverr._logEventToGraphite');

    if (isLegacyReporter) {
        sendGraph({
            ...BASE_LEGACY_PARAMS,
            label
        });
    } else {
        stats.count(PREFIX, label);
    }
};
